import {routerMiddleware} from 'connected-react-router'
import {applyMiddleware, createStore} from 'redux'
import {enableBatching} from 'redux-batched-actions'
import {composeWithDevTools} from 'redux-devtools-extension'
import {createRootReducer, ROOT_LOGOUT_ACTION_KEY} from '~/redux/reducers/root'
import {getHistory} from '~/routing/history'

// Eager, since this module builds the store at import time and the store only ever loads in the
// browser. Modules that just want the history should call `getHistory` themselves to stay lazy;
// it's idempotent, so everyone shares one instance.
const history = getHistory()

const store = createStore(
  enableBatching(createRootReducer(history)),
  composeWithDevTools(
    applyMiddleware(
      routerMiddleware(history) // for dispatching history actions to Redux
    )
  )
)

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

/** Wipes all redux state except routing. See `ROOT_LOGOUT_ACTION_KEY`'s handling in `root.ts`. */
export const logoutRedux = () => {
  store.dispatch({type: ROOT_LOGOUT_ACTION_KEY})
}
